import address from './address';
import addressValidation from './addressValidation';
import assurance from './assurance';
import auth from './auth';
import base from './base';
import dates from './dates';
import elevator from './elevator';
import estimation from './estimation';
import furnitureTransport from './furnitureTransport';
import inventory from './inventory';
import layout from './layout';
import login from './login';
import housing from './housing';
import parkingArea from './parkingArea';
import rooms from './rooms';
import services from './services';
import store from './store';
import boxConfig from './boxConfig';
import boxDelivery from './boxDelivery';
import errors from './errors';
import advice from './advice';
import profile from './profile';
import route from './route';
import validate from './validate';
import done from './done';

const lang = {
  address,
  addressValidation,
  advice,
  assurance,
  auth,
  base,
  dates,
  errors,
  elevator,
  estimation,
  furnitureTransport,
  inventory,
  layout,
  housing,
  login,
  parkingArea,
  profile,
  rooms,
  route,
  services,
  store,
  boxConfig,
  boxDelivery,
  validate,
  done,
};

export default lang;
